
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { DNSZonesInterface } from '@/services/DNS/Interfaces';

@Component({
  mixins: [Themeable],
})
export default class ActivateDNSZoneDialog extends Vue {
  @Prop() public readonly zone!: DNSZonesInterface;

  public visible: boolean = true;

  public destroyComponent(): void {
    this.$emit('close');
  }

  public async activateZone(): Promise<void> {
    await this.$emit('activate', this.zone);

    this.destroyComponent();
  }
}
